var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        ok: false,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c("a-table", {
        ref: "table",
        staticClass: "j-table-force-nowrap",
        attrs: {
          size: "middle",
          bordered: "",
          columns: _vm.columns,
          dataSource: _vm.dataSource,
          pagination: _vm.ipagination
        },
        on: { change: _vm.handleTableChange },
        scopedSlots: _vm._u([
          {
            key: "colId",
            fn: function(text, record) {
              return _c("span", {}, [
                record.colId != null
                  ? _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.unBind(record.appid)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.language["system.relieveBind"]))]
                    )
                  : _c("div", [
                      _c(
                        "a",
                        {
                          on: {
                            click: function($event) {
                              return _vm.bind(record.appid)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.language["system.bind"]))]
                      )
                    ])
              ])
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }